import Fallback from "app/components/Fallback";
import React from "react";
import StaffProfilePage from "../components/StaffProfilePage";

export const UserProfilePage = (props) => (
  <React.Suspense fallback={<Fallback />}>
    <StaffProfilePage {...props} />
  </React.Suspense>
);
